/**
 * Generated from Composio's live catalogue.
 *
 * Run `pnpm generate:composio-identifiers`; do not edit this file by hand.
 */

/**
 * Every toolkit Aline offers, from the categories and extras in
 * `external-toolkit-offering.ts`. Offering one does not allow it: an org
 * admin still has to.
 */
export const OFFERED_EXTERNAL_TOOLKITS = [
  { name: 'Attio', slug: 'attio' },
  { name: 'Basecamp', slug: 'basecamp' },
  { name: 'Blackbaud', slug: 'blackbaud' },
  { name: 'Boldsign', slug: 'boldsign' },
  { name: 'Box', slug: 'box' },
  { name: 'Capsule CRM', slug: 'capsule_crm' },
  { name: 'Confluence', slug: 'confluence' },
  { name: 'Crowdin', slug: 'crowdin' },
  { name: 'Dialpad', slug: 'dialpad' },
  { name: 'Discord', slug: 'discord' },
  { name: 'Discord Bot', slug: 'discordbot' },
  { name: 'Dropbox', slug: 'dropbox' },
  { name: 'Dynamics 365', slug: 'dynamics365' },
  { name: 'Figma', slug: 'figma' },
  { name: 'Fireflies', slug: 'fireflies' },
  { name: 'Gmail', slug: 'gmail' },
  { name: 'Gong', slug: 'gong' },
  { name: 'Google Docs', slug: 'googledocs' },
  { name: 'Google Drive', slug: 'googledrive' },
  { name: 'Google Meet', slug: 'googlemeet' },
  { name: 'Google Photos', slug: 'googlephotos' },
  { name: 'Google Slides', slug: 'googleslides' },
  { name: 'Google Super', slug: 'googlesuper' },
  { name: 'Gorgias', slug: 'gorgias' },
  { name: 'HubSpot', slug: 'hubspot' },
  { name: 'Intercom', slug: 'intercom' },
  { name: 'Microsoft Teams', slug: 'microsoft_teams' },
  { name: 'Miro', slug: 'miro' },
  { name: 'Mural', slug: 'mural' },
  { name: 'Notion', slug: 'notion' },
  { name: 'OneDrive', slug: 'one_drive' },
  { name: 'Outlook', slug: 'outlook' },
  { name: 'Pushbullet', slug: 'pushbullet' },
  { name: 'Roam', slug: 'roam' },
  { name: 'Salesforce', slug: 'salesforce' },
  { name: 'SharePoint', slug: 'share_point' },
  { name: 'Slack', slug: 'slack' },
  { name: 'Slackbot', slug: 'slackbot' },
  { name: 'Webex', slug: 'webex' },
  { name: 'WhatsApp', slug: 'whatsapp' },
  { name: 'Wrike', slug: 'wrike' },
  { name: 'Yandex', slug: 'yandex' },
  { name: 'Zendesk', slug: 'zendesk' },
  { name: 'Zeplin', slug: 'zeplin' },
  { name: 'Zoho', slug: 'zoho' },
  { name: 'Zoho Bigin', slug: 'zoho_bigin' },
  { name: 'Zoho Desk', slug: 'zoho_desk' },
  { name: 'Zoho Mail', slug: 'zoho_mail' },
  { name: 'Zoom', slug: 'zoom' },
] as const satisfies readonly { readonly name: string; readonly slug: string }[];

export type ExternalToolkitSlug = (typeof OFFERED_EXTERNAL_TOOLKITS)[number]['slug'];
